export { default } from './BasicCarousel';
